import { DefaultButton, PrimaryButton, Text } from 'office-ui-fabric-react';
import React, { Component, Fragment } from 'react';
import { DataStade } from '../../../data/DataStade';
import { Immocom } from '../../../specifique/immocom';
import { EUIDialog } from '../../EUI/EUIDialog';
import { EUITextField } from '../../EUI/EUITextField';
import { ProgressIndicatorChargement } from '../../Loader/ProgressIndicatorChargement';

export class DialogNomStade extends Component {

    static defaultProps = {
        idOperation: null,
        isOpen: false,
        onDismiss: () => null,
        onEnregistrement: (stade) => null,
        stade: {},
    };

    static defaultState = {
        hidden: true,
        nomStade: "",
        onActiveBoutonEnregistrer: false,
    };

    constructor(props) {
        super(props);
        this.state = { ...DialogNomStade.defaultState };
        this.deferredValidation = window.setTimeout(null);
    };

    _enregistrer = () => {

        this.setState({
            enCoursDeTraitement: true,
            hidden: true,
            messageEnCoursTraitement: "Mise à jour du stade en cours..."
        });

        const { idOperation, onEnregistrement, stade } = this.props;
        const { nomStade } = this.state;

        DataStade._onEnregistrementStade({ ...stade, idOperation, nomStade })
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, { ...DialogNomStade.defaultState }, onEnregistrement);
                }
                else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
            });

    };

    _onChange = (event, newValue) => {
        this.setState({ nomStade: newValue }, () => {
            window.clearTimeout(this.deferredValidation);
            this.deferredValidation = window.setTimeout(this._onVerificationFormulaire, 500);
        });
    };

    _onVerificationFormulaire = () => {
        const { stade } = this.props;
        const { nomStade } = this.state;
        Immocom.fiche()._validationFormulaire(this, "Stade", { ...stade, nomStade }, "Modification")
    };

    componentDidUpdate = (prevProps) => {
        const { isOpen, stade } = this.props;
        if (isOpen && !prevProps.isOpen) // Equivalent onOpen
            this.setState({
                hidden: false,
                nomStade: stade.nomStade
            });
    };

    render = () => {

        const { isOpen, onDismiss, stade } = this.props;
        const { autresEcheanciersLies } = stade;
        const { enCoursDeTraitement, hidden, messageEnCoursTraitement, nomStade, onActiveBoutonEnregistrer } = this.state;

        var echeanciersSansAvancement = [];
        var echeanciersAvecAvancement = [];
        if (!!autresEcheanciersLies && Array.isArray(autresEcheanciersLies)) {
            autresEcheanciersLies.forEach(echeancier => {
                if (echeancier.estStadeAvance) echeanciersAvecAvancement.push(echeancier);
                else echeanciersSansAvancement.push(echeancier);
            })
        }

        return <Fragment>
            {enCoursDeTraitement ? <ProgressIndicatorChargement label={messageEnCoursTraitement} /> : null}
            <EUIDialog
                buttons={[
                    <PrimaryButton key="confirm" onClick={this._enregistrer} text="Enregistrer" disabled={!onActiveBoutonEnregistrer} />,
                    <DefaultButton key="cancel" onClick={onDismiss} text="Annuler" />
                ]}
                isOpen={isOpen && !hidden}
                onDismiss={onDismiss}
                titre="Modification d'un libellé de stade"
            >
                {(echeanciersSansAvancement.length > 0 || echeanciersAvecAvancement.length > 0) &&
                    <Fragment>

                        <Text styles={{ root: { color: "red", fontWeight: "bold" } }}>Attention !</Text><br />

                        {echeanciersSansAvancement.length > 0 &&
                            <Fragment>
                                <Text>La mise à jour du libellé de ce stade impactera également les échéanciers suivants :</Text>
                                <ul>{echeanciersSansAvancement.map((echeancier, index) => <li key={index}>{echeancier.nomEcheancier}</li>)}</ul>
                            </Fragment>
                        }

                        {echeanciersAvecAvancement.length > 0 &&
                            <Fragment>
                                <Text>Le libellé ne pourra être mis à jour sur les échéanciers ci-dessous car un avancement travaux a déjà été déclaré :</Text>
                                <ul>{echeanciersAvecAvancement.map((echeancier, index) => <li key={index}>{echeancier.nomEcheancier}</li>)}</ul>
                            </Fragment>
                        }

                    </Fragment>
                }

                <EUITextField
                    label="Nom du stade"
                    maxLength={100}
                    onChange={this._onChange}
                    required
                    value={nomStade || ""}
                />
            </EUIDialog>
        </Fragment>;

    };

};